// todo: remake to anchors, use css smooth scrolling
export const DealSubnav = {
	offsetReserveGap: 60,

	selectors: {
		mainSelector: document.querySelector('.js-dealsubnav--main'),
		stickySelector: Array.prototype.slice.call(document.querySelectorAll('.js-dealsubnav--sticky')),
		linkSelector: Array.prototype.slice.call(document.querySelectorAll('.js-dealsubnav--link'))
	},

	init: function () {
		let self = this;

		if (!self.selectors.mainSelector || !self.selectors.stickySelector.length) {
			return;
		}

		window.addEventListener('scroll', function (event) {
			let top = window.pageYOffset || document.documentElement.scrollTop;
			let topPositionOfMain;

			if (self.selectors.mainSelector) {
				topPositionOfMain = self.getDealNavPosition(self.selectors.mainSelector);
			}

			self.stickyHeader(topPositionOfMain, top);
			self.controlActiveItem();
		});

		if (self.selectors.linkSelector) {
			self.selectors.linkSelector.forEach(x => {

				x.getBoundingClientRect().top;

				x.addEventListener('click', function (e) {
					e.preventDefault();

					let dataID = this.dataset.scroll;
					let target = document.querySelector(`[data-scroll-target=${dataID}]`);

					if (target) {
						let position = target.getBoundingClientRect().top - self.offsetReserveGap;

						window.scrollTo({
							// note: hotfix for IE11
							top: position + (window.scrollY || document.documentElement.scrollTop),
							behavior: 'smooth',
						});
					}
				});
			});
		}
	},

	selectItem: function (_selector) {
		let selectors = Array.prototype.slice.call(document.querySelectorAll(`.js-dealsubnav [data-scroll=${_selector}]`));

		selectors.forEach(x => {
			x.classList.add('is-active');
		});
	},

	unselectItems: function () {
		this.selectors.linkSelector.forEach(x => {
			x.classList.remove('is-active');
		});
	},

	getDealNavPosition: function (_selector) {
		let bodyRect = document.body.getBoundingClientRect();
		let elemRect = _selector.getBoundingClientRect();
		return elemRect.top - bodyRect.top;
	},

	stickyHeader: function (_positionMain, _scrollPosition) {
		let self = this;

		if (_scrollPosition > (_positionMain + self.offsetReserveGap + 20)) {
			this.selectors.stickySelector.forEach(x => x.classList.add('is-visible'));
		} else {
			this.selectors.stickySelector.forEach(x => x.classList.remove('is-visible'));
		}
	},

	controlActiveItem: function () {
		let self = this;

		self.selectors.linkSelector.forEach(link => {
			let target = document.querySelector(`[data-scroll-target=${link.dataset.scroll}]`);
			if (target) {
				let targetTop = target.getBoundingClientRect().top - self.offsetReserveGap * 1.5;
				let targetBottom = target.getBoundingClientRect().bottom - self.offsetReserveGap * 1.5;

				if (targetTop <= 0 && targetBottom >= 0) {
					self.unselectItems();
					self.selectItem(link.dataset.scroll);
				}
			}
		});
	}
};

DealSubnav.init();
